import { render, staticRenderFns } from "./PairRanks.vue?vue&type=template&id=3232e7f0&scoped=true"
import script from "./PairRanks.vue?vue&type=script&lang=js"
export * from "./PairRanks.vue?vue&type=script&lang=js"
import style0 from "./PairRanks.vue?vue&type=style&index=0&id=3232e7f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3232e7f0",
  null
  
)

export default component.exports